import React, { useEffect, useState } from "react";
import axios from "axios";
import httpService from "../../../../common/httpService";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import { backendUrlImages } from "../../../../constant/config";
import tripImage from "../../../../icons/tripImage.webp";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";

const ViewUserTrips = () => {
  const navigate = useNavigate();

  const [allTrips, setAllTrips] = useState([]);
  const [hasFreeTrip, setHasFreeTrip] = useState(false);
  const [selectedTripType, setSelectedTripType] = useState("private");
  const [speakerConferenceId, setSpeakerConferenceId] = useState(null);

  const token = localStorage.getItem("token");
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  // Speaker info API: token authenticate + speaker_conference_id store
  const getSpeakerInfo = async () => {
    try {
      if (!token) {
        alert("Invalid Login");
        return;
      }

      const response = await axios.get(
        "https://eventscons.com/eventbackendnew/api/speakers/info",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      console.log("Speaker info response:", response.data);

      // API response direct ho ya speaker object ke andar ho, dono handle honge
      const speakerConferenceId =
        response.data?.speaker_conference_id ||
        response.data?.speaker?.speaker_conference_id ||
        response.data?.data?.speaker_conference_id ||
        response.data?.data?.speaker?.speaker_conference_id;

      if (speakerConferenceId) {
        setSpeakerConferenceId(speakerConferenceId); // Store in state (no alert)
      } else {
        alert("speaker_conference_id response me nahi mila.");
      }

      const speakerData =
        response.data?.speaker ||
        response.data?.data?.speaker ||
        response.data?.data;

      if (speakerData?.free_trip !== undefined) {
        setHasFreeTrip(speakerData.free_trip);
      }
    } catch (error) {
      console.error(
        "Failed to fetch speaker info:",
        error.response?.data || error.message
      );

      if (error.response?.status === 401) {
        alert("Token invalid ya expire ho gaya hai. Please login again.");
      } else {
        alert(
          error.response?.data?.message ||
            "Speaker information fetch nahi ho saki."
        );
      }
    }
  };

  // Fetch trip details using speaker_conference_id
  const fetchTripDetails = async (conferenceId) => {
    try {
      const response = await axios.get(
        `https://eventscons.com/eventbackendnew/api/tripdetails/${conferenceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      console.log("Trip details response:", response.data);

      // Assuming API returns trips array or similar structure
      const tripsData = response.data?.trips || response.data?.data?.trips || response.data || [];
      
      // Replace allTrips with trip details data
      setAllTrips(Array.isArray(tripsData) ? tripsData : [tripsData]);
    } catch (error) {
      console.error(
        "Failed to fetch trip details:",
        error.response?.data || error.message
      );
      alert(
        error.response?.data?.message ||
          "Trip details fetch nahi ho saki."
      );
    }
  };

  const fetchTrips = async () => {
    try {
      const response = await httpService({
        method: "GET",
        url: `${BaseUrl}/all-trip`,
        params: {
          trip_type: selectedTripType,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
        showLoader: true,
        withToast: true,
      });

      setAllTrips(response?.trips || []);
    } catch (error) {
      console.error(
        "Failed to fetch trips:",
        error.response?.data || error.message
      );
    }
  };

  // Speaker API sirf page load/component mount par ek baar chalegi
  useEffect(() => {
    getSpeakerInfo();
  }, []);

  // Jab speaker_conference_id mil jaye, tab trip details fetch karo
  useEffect(() => {
    if (speakerConferenceId) {
      fetchTripDetails(speakerConferenceId);
    }
  }, [speakerConferenceId]);

  // ✅ Filter trips based on selectedTripType (Client-side filtering)
  const filteredTrips = allTrips.filter((trip) => {
    // Agar trip_type exist karta hai toh filter karo, warna sab dikhao
    if (trip.trip_type) {
      return trip.trip_type === selectedTripType;
    }
    // Agar trip_type nahi hai toh trip ko include mat karo (ya include karna hai toh true return karo)
    return false;
  });

  return (
    <div className="trips-page">
      <div className="trips-users-container">
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "center",
            marginBottom: "20px",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} md={6}>
            <Button
              fullWidth
              className={`trip-type-btn ${
                selectedTripType === "group" ? "active" : ""
              }`}
              onClick={() => setSelectedTripType("group")}
              sx={{
                backgroundColor: "#9B1321",
                color: "#fff",
              }}
            >
              Group Trips
            </Button>
          </Grid>

          <Grid item xs={12} md={6}>
            <Button
              fullWidth
              className={`trip-type-btn ${
                selectedTripType === "private" ? "active" : ""
              }`}
              onClick={() => setSelectedTripType("private")}
              sx={{
                backgroundColor: "#9B1321",
                color: "#fff",
              }}
            >
              Private Trips
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography textAlign="center" className="trip-note">
              You can book multiple trips based on your availability.
            </Typography>
          </Grid>
        </Grid>
      </div>

      <Grid container spacing={3}>
        {filteredTrips.length > 0 ? (
          filteredTrips.map((trip) => {
            const tripImages = trip.images?.length
              ? trip.images
              : [trip.image_1, trip.image_2].filter(Boolean);

            return (
              <Grid item xs={12} sm={6} md={4} key={trip.id}>
                <Card
                  sx={{
                    margin: "0 auto 20px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      height: 260,
                      position: "relative",
                      overflow: "hidden",
                      backgroundColor: "#f8f8f8",
                    }}
                  >
                    {tripImages.length > 0 ? (
                      <AutoSlider images={tripImages} />
                    ) : (
                      <Box
                        component="img"
                        src={tripImage}
                        alt="Trip"
                        sx={{
                          width: "100%",
                          height: 260,
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    )}
                  </Box>

                  <CardContent>
                    <Box className="main-info" sx={{ marginBottom: "10px" }}>
                      <Typography
                        variant="h6"
                        component="div"
                        className="name"
                        sx={{
                          fontWeight: "bold",
                          marginBottom: "5px",
                        }}
                      >
                        {trip.name}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        className="desc"
                        sx={{
                          height: "18vh",
                          overflow: "hidden",
                        }}
                      >
                        {trip.description}
                      </Typography>
                    </Box>

                    <Box
                      className="actions-btns"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#9B1321",
                          color: "#fff",
                        }}
                        className="view"
                        onClick={() => navigate(`/view/trip/${trip.id}`)}
                      >
                        Register for a Trip
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
        ) : (
          <p className="no-trips-message">
            No trips available for this type.
          </p>
        )}
      </Grid>
    </div>
  );
};

const AutoSlider = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Box
      sx={{
        height: 260,
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f8f8f8",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: `${images.length * 100}%`,
          height: "100%",
          transform: `translateX(-${
            currentIndex * (100 / images.length)
          }%)`,
          transition: "transform 0.6s ease-in-out",
        }}
      >
        {images.map((img, index) => (
          <Box
            key={index}
            sx={{
              width: `${100 / images.length}%`,
              flexShrink: 0,
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={`${backendUrlImages}${img}`}
              alt={`Trip ${index + 1}`}
              onError={(e) => {
                e.currentTarget.src = tripImage;
              }}
              sx={{
                width: "100%",
                height: 260,
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: 10,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          gap: 1,
          zIndex: 2,
        }}
      >
        {images.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{
              width: currentIndex === index ? 18 : 8,
              height: 8,
              borderRadius: 999,
              backgroundColor:
                currentIndex === index ? "#9B1321" : "#ffffff",
              border: "1px solid #9B1321",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ViewUserTrips;